import axios from "../customize_axios";
export const processLogin = async (email, password) => {
  // console.log(password)
  try {
    const response = await axios.post("/api/login", {
      email,
      password,
    });
    // console.log(response)
    return response;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const registerUser = async (fullName, email, phoneNumber, password) => {
  try {
    const response = await axios.post("/api/sign-up", {
      fullName,
      phoneNumber,
      email,
      password,
      role: "user",
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error("Error registering:", error);
    throw error;
  }
};

export const processLoginGG = async (code) => {
  try {
    const response = await axios.post(`/api/login/google?code=${code}`);
    console.log("Response from server:", response);
    return response;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const processLogout = async (token) => {
  try {
    const response = await axios.post("/api/log-out", {
      token,
    });
    // console.log(response)
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMyInfor = async (token) => {
  try {
    const response = await axios.get("/api/my-info", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("hehe" + JSON.stringify(response.data));
    return response;
  } catch (e) {
    console.error("error in get my infor" + e);
    throw e;
  }
};

export const setDefaultAddressByID = async (addressID, token) => {
  try {
    const response = await axios.post(
      `/api/user/address/set-default/${addressID}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    console.log("data", response.data);
    return response;
  } catch {}
};

export const updateShippingAddress = async (
  token,
  id,
  receiver,
  phoneNumber,
  address,
  city,
  district,
  ward,
  isDefault
) => {
  console.log("Thông tin nhận được:");
  console.log("ID:", id);
  console.log("Receiver (Người nhận):", receiver);
  console.log("Số điện thoại:", phoneNumber);
  console.log("Địa chỉ:", address);
  console.log("Thành phố:", city);
  console.log("Quận/Huyện:", district);
  console.log("Phường/Xã:", ward);
  console.log("Is Default (Mặc định?):", isDefault);
  try {
    const response = await axios.post(
      "/api/user/update-address",
      {
        id,
        receiver,
        phoneNumber,
        address,
        city,
        district,
        ward,
        isDefault,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    // console.log("data", response);
    return response;
  } catch (error) {
    console.error("Error updating shipping address:", error);
    throw error; // Ném lỗi để gọi hàm xử lý tiếp
  }
};

export const deleteAddress = async (addressID, token) => {
  try {
    const response = await axios.delete(
      `/api/user/address/delete/${addressID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    console.log("data xóa", response);
    return response;
  } catch (error) {
    console.error("Error deleting shipping address:", error);
    throw error;
  }
};


export const checkActivateAccount = async (verifyToken) => {
  try {
    const response = await axios.post(`/api/account/activate/${verifyToken}`);
    console.log("Account activated successfully:", response.data);
    return response;
  } catch (error) {
    console.error(
      "Error activating account:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const checkIfUserHasPassword = async (token) => {
  try {
    const response = await axios.get(
      "/api/user/is-password-set",

      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("user has password", error.response);
  }
};

export const requestForgotPass = async (email) => {
  try {
    const response = await axios.post(`/api/account/forgot-password?email=${email}`)
    console.log("requestForgotPass:", response);
    return response
  } catch (error) {
    console.log("request forgot pass fail", error.response)
    throw error
  }
};

export const checkResetPasswordToken = async (token) => {
  try {
    const response = await axios.post(`/api/account/forgot-password/confirm?token=${token}`)
    console.log("checkResetPasswordToken:", response);
    return response
  } catch (error) {
    console.log("checkResetPasswordToken fail", error.response)
    throw error
  }
}

export const resetPassWord = async (email, newPassword) => {
  try {
    const response = await axios.post("/api/account/forgot-password/reset",
      {
        email,
        newPassword,
      }
    ) 
    return response
  } catch (error){
    console.log("lỗi đặt lại mật khẩu", error)
  }
}


export const updateUserInfor = async (token, fullName, phoneNumber) => {
  try {
    const response = await axios.post("/api/user/update",
      {
        fullName,
        phoneNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    ) 
    return response
  } catch (error){
    console.log("lỗi updateUserInfor", error)
  }
}

export const changePassword = async (token, currentPassword, newPassword) => {
  try {
    const response = await axios.post("/api/user/change-password",
      {
        currentPassword,
        newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    ) 
    return response;
  } catch (error){
    console.log("lỗi updateUserInfor", error)
    throw error;
  }
}


export const setPassword = async (token, password) => {
  try {
    const response = await axios.post("/api/user/set-password",
      {
        password
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    ) 
    return response;
  } catch (error){
    console.log("lỗi updateUserInfor", error)
  }
}


export const checkIfUserHasBankAccount = async (token) => {
  try {
    const response = await axios.get(
      "/api/payment/bank-account/check",
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    // console.log("user has bank account", response);
    return response.data;

  } catch (error) {
    if (error?.response) {
      console.error("Error response:", error.response);
    } else {
      console.error("Error:", error.message || error);
    }
    throw error;
  }
};
export const getCancelReason = async (token) => {
  try {
    const response = await axios.get("/api/order/user/cancel/reason",
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }

    )
    return response.data
  } catch (error) {
    if (error?.response) {
      console.error("Error response:", error.response);
    } else {
      console.error("Error:", error.message || error);
    }
    throw error;
  }
}



export const cancelCODOrder = async (token, orderID, reasonID) => {
  try {
    const response = axios.post("/api/order/user/cancel",

      {
        orderID,
        reasonID
      },

      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    )
    console.log("hủy đơn COD", response)
    return response;
  } catch (error) {
    if (error?.response) {
      console.error("Error response:", error.response);
    } else {
      console.error("Error:", error.message || error);
    }
    throw error;
  }
}

export const addBankAccount = async (token, bankID, bankName, bankShortName, accountNumber, accountName) => {
  try {
    const response = axios.post("/api/payment/bank-account",
      
      {
        bankID,
        bankName,
        bankShortName,
        accountNumber,
        accountName
      },

      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    )
    console.log("thêm ngân hàng", response)
    return response;
  } catch (error) {
    if (error?.response) {
      console.error("Error response:", error.response);
    } else {
      console.error("Error:", error.message || error);
    }
    throw error;
  }
}



export const getAllBanks = async () => {
  try {
    const response = await axios.get("https://api.vietqr.io/v2/banks");
    return response.data;
  } catch (error) {
    console.error("Error fetching banks:", error);
    return [];
  }
};

export const getMyAccountBank = async (token) => {
  try {
    const response = await axios.get("/api/payment/bank-account", 
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    )
    console.log("bank", response.data)
    return response.data;
  } catch (error) {
    if (error?.response) {
      console.error("Error response:", error.response);
    } else {
      console.error("Error:", error.message || error);
    }
    throw error;
  }
}




export const updateBankAccount = async (token, bankID, bankName, bankShortName, accountNumber, accountName) => {
  try {
    const response = await axios.put(
      "/api/payment/bank-account",
      {
        bankID,
        bankName,
        bankShortName,
        accountNumber,
        accountName,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`, // Token cho xác thực
        },
      }
    );
    console.log("Cập nhật ngân hàng thành công", response);
    return response;
  } catch (error) {
    if (error?.response) {
      console.error("Lỗi phản hồi từ server:", error.response);
    } else {
      console.error("Lỗi:", error.message || error);
    }
    throw error;
  }
};



export const deleteBankAccount = async (token) => {
  try {
    const response = await axios.delete('/api/payment/bank-account', {
      headers: {
        Authorization: `Bearer ${token}`, // Truyền token trong header để xác thực
      },
    });
    return response; // Trả về kết quả response từ API
  } catch (error) {
    console.error('Lỗi khi xóa tài khoản ngân hàng:', error);
    throw error; // Ném lỗi nếu có
  }
};